import React, { useEffect, useState, useCallback } from "react";
import JsonSchemaForm from "./JsonSchemaForm";
import ObjectList from "../../Common/ObjectList";
import ObjectListMobile from "../../Common/ObjectListMobile";
import http from "../../Common/RestAPIHandler";
import {customizedJson} from "../../Common/Languages";

const lang = localStorage.getItem("languages");

const tableColumns = [
  {
    id: "name",
    label: customizedJson.MODELNAME[lang],
    minWidth: 200,
    sortable: true,
  },
  {
    id: "order",
    label: customizedJson.ORDER[lang],
    minWidth: 200,
    sortable: true,
  },
];

const JsonSchemas = (props) => {
  const [data, setData] = useState([]);
  const [loadData, setLoadData] = useState(false);
  const url = `json_schemas`;
  const actions = {
    delete: true,
  };

  const fetchData = useCallback(() => {
    setLoadData(true);
    http.Get(
      url,
      (data) => {
        setData(data);
        setLoadData(false);
      },
      () => {
        setLoadData(false);
      }
    );
  }, [url]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
    {!props.mobile && 
    <ObjectList
      {...props}
      moduleName={customizedJson.CustomizedDataModels[lang]}
      url={url}
      actions={actions}
      objectForm={props.user.max_custom_tab > -1 && data.length >= props.user.max_custom_tab ? null : JsonSchemaForm}
      tableColumns={tableColumns}
      searchFields={["name"]}
      orderBy={"order"}
      data={data}
      fetchData={fetchData}
      pageHeader={customizedJson.CustomizedDataModels[lang]}
      loadData={loadData}
      onDelete={()=>{window.location.reload();}}
    />
    }
    {props.mobile && 
    <ObjectListMobile
      {...props}
      moduleName={customizedJson.CustomizedDataModels[lang]}
      url={url}
      actions={actions}
      objectForm={props.user.max_custom_tab > -1 && data.length >= props.user.max_custom_tab ? null : JsonSchemaForm}
      tableColumns={tableColumns}
      searchFields={["name"]}
      orderBy={"order"}
      data={data}
      fetchData={fetchData}
      pageHeader={customizedJson.CustomizedDataModels[lang]}
      loadData={loadData}
      onDelete={()=>{window.location.reload();}}
    />
    }
    </>
  );
};

export default JsonSchemas;
